import {Grid} from "@mui/material";
import {NumericTextBoxChangeEvent, RadioButton} from "@progress/kendo-react-inputs";
import {Label} from "@progress/kendo-react-labels";
import {
  FinanceQuote,
  hasValue,
  ApplicationFinanceQuote,
  NoScrollNumericTextBox
} from "@amsanalytics/react-shared-library";
import styles from "./_finance-quoter-down-payment-option.module.scss";
import {getBackgroundColorForPotentialSolveForFields} from "../../../../utils/quoteUtils";
import QuoterError from "../../QuoterError/QuoterError";

export interface FinanceQuoterDownPaymentOptionProps {
  selectedFinanceQuoteId: string;
  onChangeSelectedQuote: (selectedFinanceQuoteId: string) => void;
  quoteOption: ApplicationFinanceQuote;
  financeQuoteFieldIsDisabled: (fieldName: string) => boolean;
  downPaymentErrorMessage: string | undefined;
  paymentErrorMessage: string | undefined;
  onChangeSingleField: <K extends keyof FinanceQuote>(fieldName: K, value: FinanceQuote[K], applicationQuoteId?: string) => void;
}

export default function FinanceQuoterDownPaymentOption(props: FinanceQuoterDownPaymentOptionProps) {
  return (
    <div className={styles.downPaymentInputs} style={{paddingTop: "10px", paddingLeft: "5px", paddingRight: "5px"}}>
      <Grid container spacing={1} direction="row" className={styles.downPaymentInputs} >
        <Grid item xs={12} sm={12} md={12} lg={12} xl={6} style={{paddingTop: "0px"}}>
          <RadioButton
            checked={props.selectedFinanceQuoteId === props.quoteOption.id}
            onClick={() => props.onChangeSelectedQuote(props.quoteOption.id)}
            size={"small"}
            style={{padding: "0px"}}
            name={"downPayment"}
          >
            <Label style={{paddingLeft: "3px", fontSize: 12, color: "#757575"}}>
              {`Cash Down ${props.quoteOption.sequence}`}
            </Label>
          </RadioButton>
          <NoScrollNumericTextBox
            readOnly={props.financeQuoteFieldIsDisabled("downPayment")}
            valid={!hasValue(props.downPaymentErrorMessage)}
            value={props.quoteOption.downPayment}
            spinners={false}
            format="c2"
            onChange={(e: NumericTextBoxChangeEvent) => props.onChangeSingleField('downPayment', Number(e.target.value), props.quoteOption.id)}
            style={{
              ...getBackgroundColorForPotentialSolveForFields("downPayment", props.quoteOption.solveFor),
              width: "100%"
            }}
          />
          <QuoterError message={props.downPaymentErrorMessage}/>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={6}>
          <NoScrollNumericTextBox
            readOnly={props.financeQuoteFieldIsDisabled("payment")}
            valid={!hasValue(props.paymentErrorMessage)}
            label={(props.quoteOption.numberOfRegularPayments ?? 0) > 0 ? `${props.quoteOption.numberOfRegularPayments} Payments of` : 'Payment'}
            value={props.quoteOption.payment}
            spinners={false}
            format="c2"
            onChange={(e: NumericTextBoxChangeEvent) => props.onChangeSingleField('payment', Number(e.target.value), props.quoteOption.id)}
            style={{
              ...getBackgroundColorForPotentialSolveForFields("payment", props.quoteOption.solveFor),
              width: "100%"
            }}
          />
          <QuoterError message={props.paymentErrorMessage}/>
        </Grid>
      </Grid>
    </div>
  );
}